import { useFormikContext } from 'formik';

import { firstNamespaceError } from '@/react/portainer/policies/utils/namespace';

import { FormSection } from '@@/form-components/FormSection';
import { FormError } from '@@/form-components/FormError';

import { NamespaceSelect } from '../rbac/NamespaceSelect';

import { IngressRulesDatatable } from './IngressRulesDatatable';
import { EgressRulesDatatable } from './EgressRulesDatatable';
import { KubernetesNetworkSecurityFormValues } from './types';

export function KubernetesNetworkSecurityFormFields() {
  const { values, setFieldValue, errors } =
    useFormikContext<KubernetesNetworkSecurityFormValues>();

  // errors.namespaces is a plain string for array-level failures (e.g. "at
  // least one namespace is required") but a sparse array of per-item errors
  // for the uniqueness/format checks — firstNamespaceError normalizes both.
  const namespacesError = firstNamespaceError(errors.namespaces);

  return (
    <>
      <FormSection title="Namespaces *">
        <p className="text-muted mb-2 text-xs">
          NetworkPolicy objects are created in each of these namespaces. Type to
          add one or more namespaces, separating them with commas or spaces.
        </p>
        <NamespaceSelect
          selectedNamespaces={values.namespaces.map((item) => item.namespace)}
          onChange={(namespaces) =>
            setFieldValue(
              'namespaces',
              namespaces.map((namespace) => ({ namespace }))
            )
          }
          namespaces={[]}
          data-cy="kubernetes-network-security-namespaces-input"
        />
        {namespacesError && <FormError>{namespacesError}</FormError>}
      </FormSection>
      <FormSection title="Traffic Rules">
        <div className="-mx-4">
          <IngressRulesDatatable />
        </div>
        <div className="-mx-4">
          <EgressRulesDatatable />
        </div>
      </FormSection>
    </>
  );
}
